var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SearchMode } from "./types";
import { mergeDeepRight } from "ramda";
export var createSearchReducer = function (getCriteriaFromPage) {
    var resetPageInfo = function (currentCriteria, noPageReset, pageSize) {
        var _a;
        if (noPageReset) {
            return currentCriteria;
        }
        return (_a = getCriteriaFromPage === null || getCriteriaFromPage === void 0 ? void 0 : getCriteriaFromPage(1, pageSize, currentCriteria)) !== null && _a !== void 0 ? _a : currentCriteria;
    };
    return function (state, action) {
        var _a, _b;
        switch (action.type) {
            case "SET_CRITERIA":
                if (state.criteria.criteria === action.payload.criteria) {
                    return state;
                }
                var noPageReset_ = (_a = action.payload.options) === null || _a === void 0 ? void 0 : _a.noPageReset;
                return __assign(__assign({}, state), { criteria: __assign(__assign({}, resetPageInfo(state.criteria, noPageReset_)), action.payload.criteria), options: action.payload.options, pageNumber: noPageReset_ ? state.pageNumber : 1 });
            case "UPDATE_CRITERIA":
                var noPageReset = (_b = action.payload.options) === null || _b === void 0 ? void 0 : _b.noPageReset;
                return __assign(__assign({}, state), { criteria: __assign(__assign({}, resetPageInfo(state.criteria, noPageReset)), { criteria: mergeDeepRight(state.criteria.criteria, action.payload.criteria) }), options: action.payload.options, pageNumber: noPageReset ? state.pageNumber : 1 });
            case "SET_FAVORITES":
                if (state.criteria.favorites === action.payload) {
                    return state;
                }
                return __assign(__assign({}, state), { criteria: __assign(__assign({}, state.criteria), { favorites: action.payload }), options: undefined });
            case "SET_ALERTED":
                if (state.criteria.alerted === action.payload) {
                    return state;
                }
                return __assign(__assign({}, state), { criteria: __assign(__assign({}, state.criteria), { alerted: action.payload }), options: undefined });
            case "SET_SHOW_ALERTED_FIRST":
                if (state.criteria.alerted === action.payload) {
                    return state;
                }
                return __assign(__assign({}, state), { criteria: __assign(__assign({}, resetPageInfo(state.criteria, false)), { showAlertedFirst: action.payload }), pageNumber: 1, options: undefined });
            case "SET_SEARCH_MODE":
                if (state.criteria.searchMode === action.payload) {
                    return state;
                }
                if (!state.criteria.favorites && action.payload === SearchMode.Favorites) {
                    return state;
                }
                return __assign(__assign({}, state), { pageNumber: 1, criteria: __assign(__assign({}, resetPageInfo(state.criteria, false)), { searchMode: action.payload }), options: undefined });
            case "SET_PAGE_NUMBER":
                if (state.pageNumber === action.payload.pageNumber) {
                    return state;
                }
                var criteria = getCriteriaFromPage === null || getCriteriaFromPage === void 0 ? void 0 : getCriteriaFromPage(action.payload.pageNumber, undefined, state.criteria);
                return __assign(__assign({}, state), { pageNumber: action.payload.pageNumber, options: __assign(__assign({}, action.payload.options), { pageChange: true }), criteria: criteria !== null && criteria !== void 0 ? criteria : state.criteria });
            case "SET_PAGE_SIZE":
                return __assign(__assign({}, state), { criteria: resetPageInfo(state.criteria, false, action.payload), pageNumber: 1, options: undefined });
        }
        return state;
    };
};
//# sourceMappingURL=search-reducers.js.map